/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Acquaintance
 */
var Acquaintance = 'http://www.w3.org/2006/vcard/ns#Acquaintance';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Agent
 */
var Agent = 'http://www.w3.org/2006/vcard/ns#Agent';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#BBS
 */
var BBS = 'http://www.w3.org/2006/vcard/ns#BBS';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Car
 */
var Car = 'http://www.w3.org/2006/vcard/ns#Car';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Cell
 */
var Cell = 'http://www.w3.org/2006/vcard/ns#Cell';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Child
 */
var Child = 'http://www.w3.org/2006/vcard/ns#Child';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Colleague
 */
var Colleague = 'http://www.w3.org/2006/vcard/ns#Colleague';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Contact
 */
var Contact = 'http://www.w3.org/2006/vcard/ns#Contact';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Coresident
 */
var Coresident = 'http://www.w3.org/2006/vcard/ns#Coresident';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Coworker
 */
var Coworker = 'http://www.w3.org/2006/vcard/ns#Coworker';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Crush
 */
var Crush = 'http://www.w3.org/2006/vcard/ns#Crush';
/**
 *
 *
 * null
 * Note that `Date` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * http://www.w3.org/2006/vcard/ns#Date
 */
var Date__workaround = 'http://www.w3.org/2006/vcard/ns#Date';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Dom
 */
var Dom = 'http://www.w3.org/2006/vcard/ns#Dom';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Emergency
 */
var Emergency = 'http://www.w3.org/2006/vcard/ns#Emergency';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Fax
 */
var Fax = 'http://www.w3.org/2006/vcard/ns#Fax';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Female
 */
var Female = 'http://www.w3.org/2006/vcard/ns#Female';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Friend
 */
var Friend = 'http://www.w3.org/2006/vcard/ns#Friend';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Home
 */
var Home = 'http://www.w3.org/2006/vcard/ns#Home';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#ISDN
 */
var ISDN = 'http://www.w3.org/2006/vcard/ns#ISDN';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Internet
 */
var Internet = 'http://www.w3.org/2006/vcard/ns#Internet';
/**
 *
 *
 * null
 * Note that `Intl` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * http://www.w3.org/2006/vcard/ns#Intl
 */
var Intl__workaround = 'http://www.w3.org/2006/vcard/ns#Intl';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Kin
 */
var Kin = 'http://www.w3.org/2006/vcard/ns#Kin';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Label
 */
var Label = 'http://www.w3.org/2006/vcard/ns#Label';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Male
 */
var Male = 'http://www.w3.org/2006/vcard/ns#Male';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Me
 */
var Me = 'http://www.w3.org/2006/vcard/ns#Me';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Met
 */
var Met = 'http://www.w3.org/2006/vcard/ns#Met';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Modem
 */
var Modem = 'http://www.w3.org/2006/vcard/ns#Modem';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Msg
 */
var Msg = 'http://www.w3.org/2006/vcard/ns#Msg';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Muse
 */
var Muse = 'http://www.w3.org/2006/vcard/ns#Muse';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Neighbor
 */
var Neighbor = 'http://www.w3.org/2006/vcard/ns#Neighbor';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#None
 */
var None = 'http://www.w3.org/2006/vcard/ns#None';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Other
 */
var Other = 'http://www.w3.org/2006/vcard/ns#Other';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#PCS
 */
var PCS = 'http://www.w3.org/2006/vcard/ns#PCS';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Pager
 */
var Pager = 'http://www.w3.org/2006/vcard/ns#Pager';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Parcel
 */
var Parcel = 'http://www.w3.org/2006/vcard/ns#Parcel';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Parent
 */
var Parent = 'http://www.w3.org/2006/vcard/ns#Parent';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Postal
 */
var Postal = 'http://www.w3.org/2006/vcard/ns#Postal';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Pref
 */
var Pref = 'http://www.w3.org/2006/vcard/ns#Pref';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Sibling
 */
var Sibling = 'http://www.w3.org/2006/vcard/ns#Sibling';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Spouse
 */
var Spouse = 'http://www.w3.org/2006/vcard/ns#Spouse';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Sweetheart
 */
var Sweetheart = 'http://www.w3.org/2006/vcard/ns#Sweetheart';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Tel
 */
var Tel = 'http://www.w3.org/2006/vcard/ns#Tel';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Text
 */
var Text = 'http://www.w3.org/2006/vcard/ns#Text';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#TextPhone
 */
var TextPhone = 'http://www.w3.org/2006/vcard/ns#TextPhone';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Unknown
 */
var Unknown = 'http://www.w3.org/2006/vcard/ns#Unknown';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Video
 */
var Video = 'http://www.w3.org/2006/vcard/ns#Video';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Voice
 */
var Voice = 'http://www.w3.org/2006/vcard/ns#Voice';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Work
 */
var Work = 'http://www.w3.org/2006/vcard/ns#Work';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#X400
 */
var X400 = 'http://www.w3.org/2006/vcard/ns#X400';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#adr
 */
var adr = 'http://www.w3.org/2006/vcard/ns#adr';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#agent
 */
var agent = 'http://www.w3.org/2006/vcard/ns#agent';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#anniversary
 */
var anniversary = 'http://www.w3.org/2006/vcard/ns#anniversary';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#bday
 */
var bday = 'http://www.w3.org/2006/vcard/ns#bday';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#category
 */
var category = 'http://www.w3.org/2006/vcard/ns#category';
/**
 *
 *
 * null
 * Note that `class` is a reserved Javascript keyword, and is therefore suffixed by `__workaround`.
 * For a list of reserved keywords, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar#Keywords.
 *
 * http://www.w3.org/2006/vcard/ns#class
 */
var class__workaround = 'http://www.w3.org/2006/vcard/ns#class';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#email
 */
var email = 'http://www.w3.org/2006/vcard/ns#email';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#geo
 */
var geo = 'http://www.w3.org/2006/vcard/ns#geo';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasAdditionalName
 */
var hasAdditionalName = 'http://www.w3.org/2006/vcard/ns#hasAdditionalName';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasCalendarBusy
 */
var hasCalendarBusy = 'http://www.w3.org/2006/vcard/ns#hasCalendarBusy';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasCalendarLink
 */
var hasCalendarLink = 'http://www.w3.org/2006/vcard/ns#hasCalendarLink';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasCalendarRequest
 */
var hasCalendarRequest = 'http://www.w3.org/2006/vcard/ns#hasCalendarRequest';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasCategory
 */
var hasCategory = 'http://www.w3.org/2006/vcard/ns#hasCategory';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasCountryName
 */
var hasCountryName = 'http://www.w3.org/2006/vcard/ns#hasCountryName';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasFN
 */
var hasFN = 'http://www.w3.org/2006/vcard/ns#hasFN';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasFamilyName
 */
var hasFamilyName = 'http://www.w3.org/2006/vcard/ns#hasFamilyName';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasGender
 */
var hasGender = 'http://www.w3.org/2006/vcard/ns#hasGender';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasGivenName
 */
var hasGivenName = 'http://www.w3.org/2006/vcard/ns#hasGivenName';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasHonorificPrefix
 */
var hasHonorificPrefix = 'http://www.w3.org/2006/vcard/ns#hasHonorificPrefix';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasHonorificSuffix
 */
var hasHonorificSuffix = 'http://www.w3.org/2006/vcard/ns#hasHonorificSuffix';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasInstantMessage
 */
var hasInstantMessage = 'http://www.w3.org/2006/vcard/ns#hasInstantMessage';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasLanguage
 */
var hasLanguage = 'http://www.w3.org/2006/vcard/ns#hasLanguage';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasLocality
 */
var hasLocality = 'http://www.w3.org/2006/vcard/ns#hasLocality';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasNickname
 */
var hasNickname = 'http://www.w3.org/2006/vcard/ns#hasNickname';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasNote
 */
var hasNote = 'http://www.w3.org/2006/vcard/ns#hasNote';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasOrganizationName
 */
var hasOrganizationName = 'http://www.w3.org/2006/vcard/ns#hasOrganizationName';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasOrganizationUnit
 */
var hasOrganizationUnit = 'http://www.w3.org/2006/vcard/ns#hasOrganizationUnit';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasPostalCode
 */
var hasPostalCode = 'http://www.w3.org/2006/vcard/ns#hasPostalCode';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasRegion
 */
var hasRegion = 'http://www.w3.org/2006/vcard/ns#hasRegion';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasRelated
 */
var hasRelated = 'http://www.w3.org/2006/vcard/ns#hasRelated';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasRole
 */
var hasRole = 'http://www.w3.org/2006/vcard/ns#hasRole';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasSource
 */
var hasSource = 'http://www.w3.org/2006/vcard/ns#hasSource';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasStreetAddress
 */
var hasStreetAddress = 'http://www.w3.org/2006/vcard/ns#hasStreetAddress';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasTitle
 */
var hasTitle = 'http://www.w3.org/2006/vcard/ns#hasTitle';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasUID
 */
var hasUID = 'http://www.w3.org/2006/vcard/ns#hasUID';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasValue
 */
var hasValue = 'http://www.w3.org/2006/vcard/ns#hasValue';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#label
 */
var label = 'http://www.w3.org/2006/vcard/ns#label';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#language
 */
var language = 'http://www.w3.org/2006/vcard/ns#language';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#latitude
 */
var latitude = 'http://www.w3.org/2006/vcard/ns#latitude';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#longitude
 */
var longitude = 'http://www.w3.org/2006/vcard/ns#longitude';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#mailer
 */
var mailer = 'http://www.w3.org/2006/vcard/ns#mailer';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#note
 */
var note = 'http://www.w3.org/2006/vcard/ns#note';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#org
 */
var org = 'http://www.w3.org/2006/vcard/ns#org';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#prodid
 */
var prodid = 'http://www.w3.org/2006/vcard/ns#prodid';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#rev
 */
var rev = 'http://www.w3.org/2006/vcard/ns#rev';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#role
 */
var role = 'http://www.w3.org/2006/vcard/ns#role';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#title
 */
var title = 'http://www.w3.org/2006/vcard/ns#title';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#tz
 */
var tz = 'http://www.w3.org/2006/vcard/ns#tz';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#value
 */
var value = 'http://www.w3.org/2006/vcard/ns#value';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Address
 */
var Address = 'http://www.w3.org/2006/vcard/ns#Address';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Email
 */
var Email = 'http://www.w3.org/2006/vcard/ns#Email';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Group
 */
var Group = 'http://www.w3.org/2006/vcard/ns#Group';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Individual
 */
var Individual = 'http://www.w3.org/2006/vcard/ns#Individual';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Name
 */
var Name = 'http://www.w3.org/2006/vcard/ns#Name';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#VCard
 */
var VCard = 'http://www.w3.org/2006/vcard/ns#VCard';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#fn
 */
var fn = 'http://www.w3.org/2006/vcard/ns#fn';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasAddress
 */
var hasAddress = 'http://www.w3.org/2006/vcard/ns#hasAddress';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasEmail
 */
var hasEmail = 'http://www.w3.org/2006/vcard/ns#hasEmail';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasGeo
 */
var hasGeo = 'http://www.w3.org/2006/vcard/ns#hasGeo';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasKey
 */
var hasKey = 'http://www.w3.org/2006/vcard/ns#hasKey';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasLogo
 */
var hasLogo = 'http://www.w3.org/2006/vcard/ns#hasLogo';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasName
 */
var hasName = 'http://www.w3.org/2006/vcard/ns#hasName';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasPhoto
 */
var hasPhoto = 'http://www.w3.org/2006/vcard/ns#hasPhoto';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasSound
 */
var hasSound = 'http://www.w3.org/2006/vcard/ns#hasSound';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasTelephone
 */
var hasTelephone = 'http://www.w3.org/2006/vcard/ns#hasTelephone';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasURL
 */
var hasURL = 'http://www.w3.org/2006/vcard/ns#hasURL';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#key
 */
var key = 'http://www.w3.org/2006/vcard/ns#key';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#logo
 */
var logo = 'http://www.w3.org/2006/vcard/ns#logo';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#n
 */
var n = 'http://www.w3.org/2006/vcard/ns#n';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#nickname
 */
var nickname = 'http://www.w3.org/2006/vcard/ns#nickname';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#photo
 */
var photo = 'http://www.w3.org/2006/vcard/ns#photo';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#sound
 */
var sound = 'http://www.w3.org/2006/vcard/ns#sound';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#tel
 */
var tel = 'http://www.w3.org/2006/vcard/ns#tel';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#url
 */
var url = 'http://www.w3.org/2006/vcard/ns#url';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Location
 */
var Location = 'http://www.w3.org/2006/vcard/ns#Location';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#hasMember
 */
var hasMember = 'http://www.w3.org/2006/vcard/ns#hasMember';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#locality
 */
var locality = 'http://www.w3.org/2006/vcard/ns#locality';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#region
 */
var region = 'http://www.w3.org/2006/vcard/ns#region';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Organization
 */
var Organization = 'http://www.w3.org/2006/vcard/ns#Organization';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Gender
 */
var Gender = 'http://www.w3.org/2006/vcard/ns#Gender';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Kind
 */
var Kind = 'http://www.w3.org/2006/vcard/ns#Kind';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#Type
 */
var Type = 'http://www.w3.org/2006/vcard/ns#Type';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#TelephoneType
 */
var TelephoneType = 'http://www.w3.org/2006/vcard/ns#TelephoneType';
/**
 *
 *
 *
 *
 * http://www.w3.org/2006/vcard/ns#RelatedType
 */
var RelatedType = 'http://www.w3.org/2006/vcard/ns#RelatedType';

var vcardImport = /*#__PURE__*/Object.freeze({
	Acquaintance: Acquaintance,
	Agent: Agent,
	BBS: BBS,
	Car: Car,
	Cell: Cell,
	Child: Child,
	Colleague: Colleague,
	Contact: Contact,
	Coresident: Coresident,
	Coworker: Coworker,
	Crush: Crush,
	Date__workaround: Date__workaround,
	Dom: Dom,
	Emergency: Emergency,
	Fax: Fax,
	Female: Female,
	Friend: Friend,
	Home: Home,
	ISDN: ISDN,
	Internet: Internet,
	Intl__workaround: Intl__workaround,
	Kin: Kin,
	Label: Label,
	Male: Male,
	Me: Me,
	Met: Met,
	Modem: Modem,
	Msg: Msg,
	Muse: Muse,
	Neighbor: Neighbor,
	None: None,
	Other: Other,
	PCS: PCS,
	Pager: Pager,
	Parcel: Parcel,
	Parent: Parent,
	Postal: Postal,
	Pref: Pref,
	Sibling: Sibling,
	Spouse: Spouse,
	Sweetheart: Sweetheart,
	Tel: Tel,
	Text: Text,
	TextPhone: TextPhone,
	Unknown: Unknown,
	Video: Video,
	Voice: Voice,
	Work: Work,
	X400: X400,
	adr: adr,
	agent: agent,
	anniversary: anniversary,
	bday: bday,
	category: category,
	class__workaround: class__workaround,
	email: email,
	geo: geo,
	hasAdditionalName: hasAdditionalName,
	hasCalendarBusy: hasCalendarBusy,
	hasCalendarLink: hasCalendarLink,
	hasCalendarRequest: hasCalendarRequest,
	hasCategory: hasCategory,
	hasCountryName: hasCountryName,
	hasFN: hasFN,
	hasFamilyName: hasFamilyName,
	hasGender: hasGender,
	hasGivenName: hasGivenName,
	hasHonorificPrefix: hasHonorificPrefix,
	hasHonorificSuffix: hasHonorificSuffix,
	hasInstantMessage: hasInstantMessage,
	hasLanguage: hasLanguage,
	hasLocality: hasLocality,
	hasNickname: hasNickname,
	hasNote: hasNote,
	hasOrganizationName: hasOrganizationName,
	hasOrganizationUnit: hasOrganizationUnit,
	hasPostalCode: hasPostalCode,
	hasRegion: hasRegion,
	hasRelated: hasRelated,
	hasRole: hasRole,
	hasSource: hasSource,
	hasStreetAddress: hasStreetAddress,
	hasTitle: hasTitle,
	hasUID: hasUID,
	hasValue: hasValue,
	label: label,
	language: language,
	latitude: latitude,
	longitude: longitude,
	mailer: mailer,
	note: note,
	org: org,
	prodid: prodid,
	rev: rev,
	role: role,
	title: title,
	tz: tz,
	value: value,
	Address: Address,
	Email: Email,
	Group: Group,
	Individual: Individual,
	Name: Name,
	VCard: VCard,
	fn: fn,
	hasAddress: hasAddress,
	hasEmail: hasEmail,
	hasGeo: hasGeo,
	hasKey: hasKey,
	hasLogo: hasLogo,
	hasName: hasName,
	hasPhoto: hasPhoto,
	hasSound: hasSound,
	hasTelephone: hasTelephone,
	hasURL: hasURL,
	key: key,
	logo: logo,
	n: n,
	nickname: nickname,
	photo: photo,
	sound: sound,
	tel: tel,
	url: url,
	Location: Location,
	hasMember: hasMember,
	locality: locality,
	region: region,
	Organization: Organization,
	Gender: Gender,
	Kind: Kind,
	Type: Type,
	TelephoneType: TelephoneType,
	RelatedType: RelatedType
});

export { category as $, Acquaintance as A, BBS as B, Car as C, Date__workaround as D, Emergency as E, Fax as F, Text as G, Home as H, ISDN as I, TextPhone as J, Kin as K, Label as L, Male as M, Neighbor as N, Other as O, PCS as P, Voice as Q, adr as R, Sibling as S, Tel as T, Unknown as U, Video as V, Work as W, X400 as X, agent as Y, anniversary as Z, bday as _, Agent as a, n as a$, class__workaround as a0, email as a1, geo as a2, hasAdditionalName as a3, hasCalendarBusy as a4, hasCalendarLink as a5, hasCalendarRequest as a6, hasCategory as a7, hasCountryName as a8, hasFN as a9, note as aA, org as aB, prodid as aC, rev as aD, role as aE, title as aF, tz as aG, value as aH, Address as aI, Email as aJ, Group as aK, Individual as aL, Name as aM, VCard as aN, fn as aO, hasAddress as aP, hasEmail as aQ, hasGeo as aR, hasKey as aS, hasLogo as aT, hasName as aU, hasPhoto as aV, hasSound as aW, hasTelephone as aX, hasURL as aY, key as aZ, logo as a_, hasFamilyName as aa, hasGender as ab, hasGivenName as ac, hasHonorificPrefix as ad, hasHonorificSuffix as ae, hasInstantMessage as af, hasLanguage as ag, hasLocality as ah, hasNickname as ai, hasNote as aj, hasOrganizationName as ak, hasOrganizationUnit as al, hasPostalCode as am, hasRegion as an, hasRelated as ao, hasRole as ap, hasSource as aq, hasStreetAddress as ar, hasTitle as as, hasUID as at, hasValue as au, label as av, language as aw, latitude as ax, longitude as ay, mailer as az, Cell as b, nickname as b0, photo as b1, sound as b2, tel as b3, url as b4, Location as b5, hasMember as b6, locality as b7, region as b8, Organization as b9, Gender as ba, Kind as bb, Type as bc, TelephoneType as bd, RelatedType as be, vcardImport as bf, Child as c, Colleague as d, Contact as e, Coresident as f, Coworker as g, Crush as h, Dom as i, Female as j, Friend as k, Internet as l, Intl__workaround as m, Me as n, Met as o, Modem as p, Msg as q, Muse as r, None as s, Pager as t, Parcel as u, Parent as v, Postal as w, Pref as x, Spouse as y, Sweetheart as z };
